<template>
  <div class="bg-[#fff] h-full overflow-hidden py-4">
    <div class="md-layout">
      <div class="md-layout-item md-size-100">
        <md-field class="pb-0">
          <label>Search by group name</label>
          <md-input class="mb-3" @input="debounceSearchKey"></md-input>
        </md-field>
      </div>
    </div>

    <div class="parent" ref="groupsRefs">
      <ul class="child overflow-y-auto">
        <li
          v-for="(room, index) in groups"
          :key="'group' + index"
          :class="{ 'bg-[#ebf5ef]': room.room_id === currentId }"
          class="cursor-pointer hover:bg-[#ebf5ef] min-h-[50px]"
          @click="setUserClicked(room, $event)"
        >
          <div class="flex">
            <div
              @click="getRoomChat(room)"
              class="flex items-center w-full pl-2 my-1"
            >
              <img
                class=" w-[45px] h-[45px] rounded-2xl mr-4"
                :src="room.image || '/img/square_avt_default.jpg'"
              />
              <div>
                <p :class="{ 'font-medium': room.unread }">
                  {{ room.name }}
                </p>
                <p
                  class="text-[12px]"
                  :class="room.unread ? 'font-medium' : 'text-[#aaa]'"
                >
                  {{ room.time }}
                </p>
              </div>
              <div v-if="room.unread" class="flex text-right grow mr-6">
                <span class="new-message"></span>
              </div>
            </div>
            <div
              v-if="room.author"
              @click.prevent="toggleBar(index)"
              class="font-light my-auto cursor-pointer relative"
            >
              <md-icon class="hover:font-bold">more_vert</md-icon>
              <div
                v-click-outside="closeAllPopup"
                v-if="isConfirmDelete && index === indexSelected"
                class="absolute bg-[#eee] rounded-md z-50"
                style="right: 20%"
              >
                <div
                  @click="confirmDeleteGroup(room)"
                  class="text-[#D6030C] hover:bg-[#F3D7D5] p-2 min-w-[80px] border-1 rounded-md font-medium"
                >
                  {{ $t("common.delete") }}
                </div>
                <div
                  @click="editGroup(room)"
                  class="text-[#08980E] hover:bg-[#C7E2D0] p-2 min-w-[80px] border-1 rounded-md font-medium"
                >
                  {{ $t("common.edit") }}
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import debounce from "lodash/debounce";
import Swal from "sweetalert2";
import { mapGetters } from "vuex";
import { service_paths } from "../../../../../constants/Services";

export default {
  components: {},
  props: ["groups"],
  inject: ["routerToRoomChat"],
  data() {
    return {
      currentId: null,
      isConfirmDelete: false,
      isLoading: false,
      limit: 10,
      indexSelected: null
    };
  },
  computed: {
    debounceSearchKey() {
      const self = this;
      return debounce(function(query) {
        self.$emit("searchUser", query);
      }, 500);
    },
    ...mapGetters("user", ["role"])
  },
  watch: {
    groups: {
      deep: true,
      handler: function() {
        this.isLoading = false;
      }
    }
  },
  methods: {
    editGroup(room) {
      this.$emit("editGroup", room);
    },
    toggleBar(index) {
      this.isConfirmDelete = !this.isConfirmDelete;
      this.indexSelected = index;
    },
    closeAllPopup() {
      this.isConfirmDelete = false;
    },
    setUserClicked(user, event) {
      if (event.target.textContent === "more_vert ") return;
      this.currentId = user.room_id;
      setTimeout(() => (user.unread = 0), 2000);
    },
    getRoomChat(groupChat) {
      this.isConfirmDelete = false;
      this.routerToRoomChat(groupChat, true);
      this.$axios.post(
        `${service_paths.chat}/reset-number-unread-messages/room/${groupChat.room_id}`,
        { user_id: groupChat.user_id }
      );
    },
    confirmDeleteGroup(user) {
      Swal.fire({
        title: this.$t("common.confirmation"),
        text: "Delete",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: "Delete",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$emit("deleteGroup", user.id);
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.grow {
  flex-grow: 1;
}

.new-message {
  @apply rounded-full bg-[#f44336] text-[11px] right-[-11px] top-[-14px] w-3 h-3;
}

.avatar {
  @apply object-cover rounded-2xl w-[45px] h-[45px] text-[#fff] font-medium items-center;
}

.border-white {
  border: 2px solid #fff;
}

.border-green {
  border: 2px solid #5dcc7f;
}

.parent {
  width: 100%;
  height: 100%;
  overflow: hidden;

  .child {
    width: 100%;
    height: calc(100% - 56px);
    overflow-y: scroll;
    padding-right: 17px; /* Increase/decrease this value for cross-browser compatibility */
    box-sizing: content-box; /* So the width will be 100% + 17px */
  }
}

::-webkit-scrollbar {
  appearance: none;
  width: 7px;
  height: 7px;
}

::-webkit-scrollbar-thumb {
  background: #dadada;
  border-radius: 25px;
}
</style>
